<template>
  <div class="animated fadeIn">
    <div v-if="$route.name == 'PersonDuplicates'" class="row">
      <div class="col-12">
        <div class="card">
          <div class="card-header">
            <i class="fa fa-align-justify" /> People
            <router-link
              class="btn btn-primary btn-sm pull-right"
              :to="{ name: 'People'}"
            >
              Return to People list
            </router-link>
          </div>
          <div class="card-block">
            <input
              v-model="searchQuery"
              type="text"
              class="form-control"
              placeholder="Search by string"
            >
          </div>
          <div class="card-block spinner-parent">
            <spinner ref="spinner" size="md" text="Loading ..." />

            <div class="table-responsive">
              <table v-if="total" class="entities table table-bordered table-striped table-sm">
                <thead>
                  <tr>
                    <th>Check</th>
                    <th>ID</th>
                    <th>Title</th>
                    <th>Actions</th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="item in people" :key="item.id" :data-id="item.id">
                    <td>
                      <input
                        :id="item.id"
                        v-model="selectedEntities"
                        type="checkbox"
                        :value="item.id"
                      >
                    </td>
                    <td>{{ item.id }}</td>
                    <td>{{ item.title }}</td>
                    <td class="table-list__cell--narrow">
                      <router-link
                        class="btn btn-primary btn-sm"
                        :to="{ name: 'PersonEdit', params: { id: item.id }}"
                      >
                        Edit
                      </router-link>
                      <button
                        class="btn btn-success btn-sm btn-merge"
                        @click="mergeItem(item)"
                      >
                        Merge
                        <span class="btn-loader" style="display: none;" />
                      </button>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
            <div v-if="total === 0">
              There are no obvious duplicates for this person.
              Try to search something more particular
            </div>
            <nav>
              <pager
                :total="total"
                :offset="offset"
                :size="perPage"
                @page-changed="changePage"
              />
              <button
                v-if="selectedEntities.length"
                class="btn btn-success btn-sm btn-merge-all"
                @click="mergeItems"
              >
                Merge Selected
                <span class="btn-loader" style="display: none;" />
              </button>
            </nav>
          </div>
        </div>
      </div>

      <div class="col-12">
        <div class="saving-alerts" style="margin-top: 20px;">
          <div class="alert alert-success" style="display: none;">
            Merge successed!
          </div>
          <div class="alert alert-danger" style="display: none;">
            {{ saveErrorMessage }}
          </div>
        </div>
      </div>
    </div>
    <div class="row">
      <div class="col-12">
        <router-view />
      </div>
    </div>
  </div>
</template>

<script>
import _ from 'lodash';
import Pager from '@/global/components/Pager';

export default {
  name: 'PersonDuplicates',

  components: {
    pager: Pager,
  },

  data() {
    return {
      searchQuery: '',
      searchProcessId: null,
      total: 0,
      offset: 0,
      perPage: null,
      people: null,
      selectedEntities: [],
      saveErrorMessage: '',
    };
  },

  watch: {
    searchQuery: _.debounce(function () {
      this.offset = 0;
      this.getSource();
    }, 400),
    offset() {
      this.getSource();
    },
  },

  mounted() {
    this.getSource();
  },

  methods: {
    getSource() {
      if (this.$refs.spinner) { this.$refs.spinner.show(); }
      const searchString = encodeURI(this.searchQuery);
      const page = this.perPage ? (this.offset / this.perPage + 1) : 1;
      const searchProcessId = Math.random();
      this.searchProcessId = searchProcessId;
      this.$apiHttp.get(`${this.$config.app_api.prefix}people/${this.$route.params.id}/duplicates`, {
        params: {
          search_string: searchString,
          page,
        },
      })
        .then((response) => {
          if (this.searchProcessId === searchProcessId) {
            if (this.$refs.spinner) { this.$refs.spinner.hide(); }
            this.total = response.data.meta.pagination.total;
            this.perPage = response.data.meta.pagination.per_page;

            const peopleArr = _.cloneDeep(response.data);
            delete peopleArr.meta;
            this.people = peopleArr;
            this.selectedEntities = [];
          }
        }).catch((error) => {
          if (this.$refs.spinner) { this.$refs.spinner.hide(); }
          console.error(error);
        });
    },
    changePage(offset) {
      this.offset = offset;
    },
    mergeItem(item) {
      if (window.confirm('Do you really want to merge this persons?')) {
        $('.saving-alerts .alert').hide();
        const $mergeBtnLoader = $(`.entities tr[data-id="${item.id}"] .btn-merge .btn-loader`);
        $mergeBtnLoader.show();
        this.mergeRequest([item.id])
          .then(() => {
            this.successSave($mergeBtnLoader);
          })
          .catch((error) => {
            console.error(error);
            this.errorSave('Server Error', $mergeBtnLoader);
          });
      }
    },
    mergeItems() {
      if (window.confirm('Do you really want to merge this persons?')) {
        $('.saving-alerts .alert').hide();
        const $mergeBtnLoader = $('.btn-merge-all .btn-loader');
        $mergeBtnLoader.show();
        this.mergeRequest(this.selectedEntities)
          .then(() => {
            this.successSave($mergeBtnLoader);
          })
          .catch((error) => {
            console.error(error);
            this.errorSave('Server Error', $mergeBtnLoader);
          });
      }
    },
    mergeRequest(itemsArray) {
      return this.$apiHttp.post(
        `${this.$config.app_api.prefix}people/${this.$route.params.id}/merge`,
        { ids: itemsArray },
      );
    },
    successSave($btnLoader) {
      this.$parent.getSource();
      $('.btn-success .btn-loader').hide();
      $('.saving-alerts .alert-success').show();
      $btnLoader.hide();
      this.getSource();
    },
    errorSave(errorMessage, $btnLoader) {
      $btnLoader.hide();
      $('.btn-success .btn-loader').hide();
      this.saveErrorMessage = errorMessage;
      $('.saving-alerts .alert-danger').show();
    },
  },
};
</script>



// WEBPACK FOOTER //
// Duplicates.vue?1df277af